import React from "react";
import { MessageCircle, Users } from "lucide-react";

export default function ShareDestinationModal({ open, onClose, onSelect }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md rounded-2xl surface-card p-6 shadow-xl">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">Share Reflection</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-5">
          Choose where to share your reflection.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => onSelect("chat")}
            className="w-full flex items-center gap-3 py-3 px-4 rounded-xl bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-medium text-sm hover:opacity-90 transition"
            data-testid="share-dest-chat"
          >
            <MessageCircle className="w-5 h-5" />
            Share to Chat
          </button>

          <button
            onClick={() => onSelect("community")}
            className="w-full flex items-center gap-3 py-3 px-4 rounded-xl border border-gray-300 dark:border-slate-600 text-gray-900 dark:text-white font-medium text-sm hover:bg-gray-50 dark:hover:bg-slate-800 transition"
            data-testid="share-dest-community"
          >
            <Users className="w-5 h-5" />
            Share to Community
          </button>

          <button
            onClick={onClose}
            className="w-full py-2 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition"
            data-testid="share-dest-cancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
